<app-table-header
  (reload)="onRefreshList(false)"
  [loading]="loading"
  [withExportOption]="false"
  >
  <app-table-search-bar (search)="search($event)" [searchValue]="currentSearch"></app-table-search-bar>
</app-table-header>
<nz-table appColumnLayout id="production-orders-for-article-table"
  #tableRef
  nzShowSizeChanger
  [nzData]="data"
  [nzLoading]="loading"
  (nzCurrentPageDataChange)="onCurrentPageDataChange($event)"
  >
  <thead>
    <tr>
      <th nzColumnKey="expand"></th>
      @for (column of listOfColumns; track column) {
        <th [attr.nzColumnKey]="column.key"
          [nzSortOrder]="column.sortOrder"
          [nzSortFn]="column.sortFn"
          [nzSortDirections]="column.sortDirections"
          [nzFilterMultiple]="column.filterMultiple"
          [nzFilters]="column.listOfFilter"
          [nzFilterFn]="column.filterFn"
          [nzShowFilter]="column.showFilter"
          [nzShowSort] ="column.showOrder"
          >
          {{ column.name }}
        </th>
      }
      <th nzColumnKey="actions"></th>
    </tr>
  </thead>
  <tbody>
    @for (pOrder of listOfCurrentPageData; track pOrder) {
      <tr>
        <td [(nzExpand)]="pOrder.expand"></td>
        <td>{{pOrder.id}}</td>
        <td>{{pOrder.createdAt|dateFormat}}</td>
        <td>{{pOrder.bulkContainer.charge}}</td>
        <td>{{pOrder.bulkContainer.supplier?.name}}</td>
        <td>{{pOrder.processingDate|dateFormat}}</td>
        <td>
          @for (worker of pOrder.workers; track worker) {
            {{ worker.fullName }}<br>
          }
        </td>
        <td nzAlign="center"><app-boolean-icon [state]="pOrder.isFinished"></app-boolean-icon></td>
        <td>{{pOrder.status | statusFormat}}</td>
        <td>
          <div class="actions">
            <app-icon-button
              icon="eye"
              ariaLabel="Vorschau"
              (pressed)="togglePreview(pOrder)"
            ></app-icon-button>
            @if (pOrder.documentKey && pOrder.documentKey !== '') {
              <app-download-document [documentKey]="pOrder.documentKey"></app-download-document>
            }
          </div>
        </td>
      </tr>
      <tr [nzExpand]="pOrder.expand">
        <nz-table appColumnLayout id="production-orders-article-variants-table" #tableRef #innerTable [nzData]="pOrder.productionOrderVariants" nzSize="middle" [nzShowPagination]="false">
          <thead>
            <tr>
              <th nzColumnKey="variant">Variante</th>
              <th nzColumnKey="orderNumber">Bestellnummer</th>
              <th nzColumnKey="weight">Gewicht</th>
              <th nzColumnKey="quantity">Menge</th>
            </tr>
          </thead>
          <tbody>
            @for (variant of pOrder.productionOrderVariants; track variant) {
              <tr>
                <td>{{ variant.articleVariant?.name }}{{ variant.recipeCardVariant ? ' (' + variant.recipeCardVariant.value + ')' : '' }}</td>
                <td>{{ variant.articleVariant?.orderNumber }}</td>
                <td>{{ variant.weight }} g</td>
                <td>{{ variant.quantity }}</td>
              </tr>
            }
          </tbody>
        </nz-table>
      </tr>
    }
  </tbody>
</nz-table>

<app-export-table-modal #exportTableModalComponent></app-export-table-modal>
